import { Component, Input, OnInit } from '@angular/core';
import { UnreadNotificationsPipe } from '../../common/pipes/unread-notifications.pipe';
import { NotificationsMenuService } from '../../header/notifications-menu/notifications-menu.service';
import { CommonModule, DatePipe, LowerCasePipe, NgClass } from '@angular/common';
import { eLinkButtonTarget } from '../../common/components/general/link-button/link-button.model';
import { NotificationResults } from '../../header/notifications-menu/notifications-menu.viewmodel';
import { Router } from '@angular/router';
import { LPMI_ROUTES } from '../../common/constants/routes';
import { COMPONENT_META_DATA } from '../../common/constants/component-meta-data';
import { GtmEvent } from '../../common/models/gtm-event.model';
import { GtmService } from '../../common/services/gtm/gtm.service';
import { PageService } from '../../common/services/page/page.service';

@Component({
  selector: 'nuc-notification-link',
  imports: [CommonModule, NgClass],
  providers: [UnreadNotificationsPipe, DatePipe, LowerCasePipe],
  templateUrl: './notification-link.component.html',
  styleUrl: './notification-link.component.scss'
})
export class NotificationLinkComponent implements OnInit {
  @Input() item: NotificationResults;
  @Input() displayClass: string;
  notifications: NotificationResults[];
  unreadNotifications: NotificationResults[];
  hasUnreadNotifications: boolean = false;
  id: string;
  isRouterLink: boolean = false;
  locale: string = 'en-US';
  eLinkButtonTarget = eLinkButtonTarget;
   constructor(
    private notificationsService: NotificationsMenuService, private unreadNotificationsPipe: UnreadNotificationsPipe, private datePipe: DatePipe, private router: Router, private gtm: GtmService,
    private pageService: PageService
  ) { }
  ngOnInit(): void {
    // ngOnInit
    const sameAppUrl = window.location.origin;
    if (this.item?.linkPath?.startsWith(sameAppUrl)) {
      this.isRouterLink = true;
    }
    const pref = this.pageService.getPreferredLanguage();
    const lang = pref?.languageCode?.toLowerCase() || 'en';
    const country = pref?.countryCode?.toUpperCase() || 'US';
    this.locale = country ? `${lang}-${country}` : lang;
  }

  onLinkClick(notificationItem: NotificationResults) {
    const gtmEvent = GtmEvent.create("NOTIFICATION", 'Content', 'Redirection::Internal', notificationItem.title);
    this.gtm.pushEvent(gtmEvent);
    
    const linkPath = notificationItem.linkPath;
    if (notificationItem.type?.toLowerCase() === COMPONENT_META_DATA.ARTICLE.KEY) {      
      // Use Angular's Router for navigation
      const id = notificationItem.articleId || notificationItem.id;      
      const queryParams = { id,  linkPath}; // Prepare the query params
      this.router.navigate([LPMI_ROUTES.ARTICLE.PATH], { queryParams }); // Navigate with query params
    }
    else{
      linkPath && this.openInNewWindow(linkPath);
    }
    this.hasUnreadNotifications = true;
    let requestBody = [`${notificationItem.id}`];
    this.notificationsService.markAllasRead(requestBody).subscribe({});
  }

  openInNewWindow(link: string): void {
    window.open(link, '_blank');
  }
formatNotificationDate(value?: string): string {
    if (!value) return '';
    return new Intl.DateTimeFormat(this.locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(new Date(value));
  }

  formatNotificationTime(value?: string): string {
    if (!value) return '';
    return new Intl.DateTimeFormat(this.locale, {
      hour: 'numeric',
      minute: '2-digit'
    }).format(new Date(value));
  }
}
